"use client";

import {
  Field,
  Text,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
// import { Link } from "@repo/next-utils/router";
import Link from "next/link";
import * as Box from "@repo/ui/box";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_LABEL3 } from "@/typography-constants";
import { ArrowR } from "../../../icons";
import { arePathsEqual } from "../../utils";
import styles from "./faq-link.module.css";

export type FaqType = {
  url: { path: string };
  faqTitle: Field<string>;
  shortTitle: Field<string>;
};

export type FaqLinkType = {
  faq: FaqType;
  showArrow: boolean;
};

const FaqLink = ({ faq, showArrow }: FaqLinkType): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!faq || !faq.faqTitle.value || !faq.url.path) {
    if (!isEditing) {
      return <></>;
    }
  }

  const isSelected = arePathsEqual(
    sitecoreContext.itemPath! as string,
    faq.url.path as string,
  );

  const linkField = faq.url.path.toLocaleLowerCase();
  const title =
    faq.shortTitle && faq.shortTitle.value ? faq.shortTitle : faq.faqTitle;

  const textEl = (
    <Text
      tag={"p"}
      field={title}
      className={clsx(styles.linkListText, TYPOGRAPHY_LABEL3)}
    />
  );

  if (showArrow) {
    return (
      <Flex.Container
        align={"center"}
        justify={"space-between"}
        gap="xl"
        className={clsx(styles.topicContainer, isSelected && styles.selected)}
        asChild
      >
        <Link href={linkField} className={styles.linkListItem}>
          {textEl}
          <Box.Box className={styles.arrow}>
            <ArrowR width={16} height={16} />
          </Box.Box>
        </Link>
      </Flex.Container>
    );
  }

  return (
    <Link href={linkField} className={styles.linkListItem}>
      {textEl}
    </Link>
  );
};

export default FaqLink;
